import { Entity } from '@backstage/catalog-model';
import { FIGMA_FILE_KEY, FIGMA_NODE_IDS } from '../constants';

export const isFigmaAvailable = (entity: Entity) =>
  Boolean(
    entity?.metadata.annotations?.[FIGMA_FILE_KEY] &&
      entity?.metadata.annotations?.[FIGMA_NODE_IDS],
  );
